/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CloneEnvironmentRequestBody,
  CloneEnvironmentRequestBody$Outbound,
  CloneEnvironmentRequestBody$outboundSchema,
} from "../components/cloneenvironmentrequestbody.js";

export type CloneEnvironmentSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type CloneEnvironmentRequest = {
  /**
   * The slug of the source environment to clone
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  cloneEnvironmentRequestBody: CloneEnvironmentRequestBody;
};

/** @internal */
export type CloneEnvironmentSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CloneEnvironmentSecurity$outboundSchema: z.ZodMiniType<
  CloneEnvironmentSecurity$Outbound,
  CloneEnvironmentSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function cloneEnvironmentSecurityToJSON(
  cloneEnvironmentSecurity: CloneEnvironmentSecurity,
): string {
  return JSON.stringify(
    CloneEnvironmentSecurity$outboundSchema.parse(cloneEnvironmentSecurity),
  );
}

/** @internal */
export type CloneEnvironmentRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CloneEnvironmentRequestBody: CloneEnvironmentRequestBody$Outbound;
};

/** @internal */
export const CloneEnvironmentRequest$outboundSchema: z.ZodMiniType<
  CloneEnvironmentRequest$Outbound,
  CloneEnvironmentRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    cloneEnvironmentRequestBody: CloneEnvironmentRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      cloneEnvironmentRequestBody: "CloneEnvironmentRequestBody",
    });
  }),
);

export function cloneEnvironmentRequestToJSON(
  cloneEnvironmentRequest: CloneEnvironmentRequest,
): string {
  return JSON.stringify(
    CloneEnvironmentRequest$outboundSchema.parse(cloneEnvironmentRequest),
  );
}
